<template>
    <v-container class="my-5">
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Fraccionamiento      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            @click="getCutingLogo()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Registro del Directorio     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_schedule')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteSportSchedule()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Agregar/Modificar Horarios    -->
        <v-dialog v-model="dialog" persistent scrollable max-width="450">
          <v-form
              @submit.prevent="update
                              ? updateSportSchedue(idUpdate)
                              : addSportSchedule()"
          >
            <v-card class="elevation-5">
              <v-toolbar dark color="primary">
                <v-toolbar-title>
                  {{$t('schedule')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    class="align-self-end"
                    color="red"
                    icon
                    @click="clear(), dialog = false"
                ><v-icon>mdi-close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text>
                <v-autocomplete
                    v-model="weekday"
                    prepend-icon="mdi-soccer"
                    name="weekday"
                    item-text="name"
                    item-value="id"
                    :label="'*' + $t('weekday')"
                    :placeholder="$t('choose_day')"
                    :error-messages="errores.day"
                    :items="weekdays"
                    no-data-text="Ningún Resultado"
                    outlined
                    clearable
                    autocomplete="off"
                >
                </v-autocomplete>
                <v-autocomplete
                    v-model="initialTime"
                    prepend-icon="mdi-clock"
                    name="initialTime"
                    item-text="schedule"
                    item-value="schedule"
                    :label="'*' + $t('check_in_time')"
                    :error-messages="errores.initialTime"
                    :items="schedules"
                    no-data-text="Ningún Resultado"
                    outlined
                    clearable
                    autocomplete="off"
                >
                </v-autocomplete>
                <v-autocomplete
                    v-model="finalTime"
                    prepend-icon="mdi-clock"
                    name="finalTime"
                    item-text="schedule"
                    item-value="schedule"
                    :label="'*' + $t('check_out_time')"
                    :error-messages="errores.finalTime"
                    :items="schedules"
                    no-data-text="Ningún Resultado"
                    outlined
                    clearable
                    autocomplete="off"
                >
                </v-autocomplete>
                <v-text-field
                    v-model="instructor_name"
                    name="instructor_name"
                    counter
                    outlined
                    maxlength="100"
                    prepend-icon="mdi-account"
                    :label="$t('instructor_name')"
                    :error-messages="errores.instructor_name"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                <v-spacer/>
                <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <h2 class="subheading grey--text">{{$t('sports_schedules')}}</h2>
        <v-layout align-center justify-center fill-height>
            <v-card class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('sports_schedules')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col
                        cols="12"
                        md="8"
                    >
                      <v-autocomplete
                          v-model="idSport"
                          prepend-icon="mdi-soccer"
                          name="idSport"
                          item-text="name"
                          item-value="id"
                          :label="'*' + $t('sport')"
                          :placeholder="$t('choose_sport')"
                          :error-messages="errores.idSport"
                          :items="directorys"
                          no-data-text="Ningún Resultado"
                          outlined
                          clearable
                          @change="loadSportSchedule"
                          autocomplete="off"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4"
                    >
                        <v-layout row wrap class="justify-center">
                          <v-btn
                              v-if="getProfile.role === 1"
                              :disabled="(idSport === undefined || idSport === '')"
                              large
                              color="primary"
                              @click="update = false, cleanFields(), dialog = true"
                          >
                            {{$t('add_sport_schedule')}}
                          </v-btn>
                        </v-layout>
                    </v-col>
                  </v-row>
                </v-card-text>
            </v-card>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
          <v-row>
            <v-col>
              <v-sheet height="100%">
                <v-calendar
                    ref="calendar"
                    :now="today"
                    :value="today"
                    :events="events"
                    :event-color="getEventColor"
                    :weekdays="[1, 2, 3, 4, 5, 6]"
                    color="primary"
                    type="week"
                    @click:event="showEvent"
                    :locale="$t('region')"
                    :first-interval="14"
                    :interval-minutes="30"
                    :interval-count="30"
                    :short-intervals="false"
                    :short-weekdays="false"
                >
                </v-calendar>
                <v-menu
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                >
                  <v-card
                      color="grey lighten-4"
                      min-width="350px"
                      flat
                  >
                    <v-toolbar
                        :color="selectedEvent.color"
                        dark
                    >
                      <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="getProfile.role === 1"
                        icon
                        color="black"
                        @click="idDirectoryDelete = selectedEvent.id, deleteDialog = true"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                          v-if="getProfile.role === 1"
                          icon
                          color="black"
                          @click="fillFields(selectedEvent),
                          update = true,
                          dialog = true,
                          idUpdate = selectedEvent.id"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-card-title>{{selectedEvent.name}} - {{selectedEvent.weekday}}</v-card-title>
                      <v-card-subtitle>{{selectedEvent.initialTime}} - {{selectedEvent.finalTime}}</v-card-subtitle>
                      <!-- <v-card-subtitle v-if="selectedEvent.nameInstructors !== null" >{{ $t('instructor_name') }}: <strong>{{selectedEvent.nameInstructors}}</strong></v-card-subtitle> -->
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                          text
                          color="secondary"
                          @click="selectedOpen = false"
                      >
                        {{$t('cancelar')}}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'sports_schedules',
  created () {
    this.getSports()
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    idSport: '',
    initialTime: '',
    weekday: '',
    finalTime: '',
    initialTimeAux: '',
    finalTimeAux: '',
    header: [],
    loadingDataDirectory: false,
    loading: false,
    directorys: [],
    schedule_by_sport: [],
    weekdays: [
      {
        id: 0,
        name: 'Lunes'
      },
      {
        id: 1,
        name: 'Martes'
      },
      {
        id: 2,
        name: 'Miércoles'
      },
      {
        id: 3,
        name: 'Jueves'
      },
      {
        id: 4,
        name: 'Viernes'
      },
      {
        id: 5,
        name: 'Sábado'
      },
      {
        id: 6,
        name: 'Domingo'
      }
    ],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: '',
    today: '2019-01-07',
    selectedOpen: false,
    selectedEvent: {},
    selectedElement: null,
    events: [],
    instructor_name: '',
    schedules: [
      {
        id: 5,
        schedule: '05:00'
      },
      {
        id: 6,
        schedule: '06:00'
      },
      {
        id: 7,
        schedule: '07:00'
      },
      {
        id: 8,
        schedule: '08:00'
      },
      {
        id: 9,
        schedule: '09:00'
      },
      {
        id: 10,
        schedule: '10:00'
      },
      {
        id: 11,
        schedule: '11:00'
      },
      {
        id: 12,
        schedule: '12:00'
      },
      {
        id: 13,
        schedule: '13:00'
      },
      {
        id: 14,
        schedule: '14:00'
      },
      {
        id: 15,
        schedule: '15:00'
      },
      {
        id: 16,
        schedule: '16:00'
      },
      {
        id: 17,
        schedule: '17:00'
      },
      {
        id: 18,
        schedule: '18:00'
      },
      {
        id: 19,
        schedule: '19:00'
      },
      {
        id: 20,
        schedule: '20:00'
      },
      {
        id: 21,
        schedule: '21:00'
      }
    ]
  }),
  mounted () {
    this.$refs.calendar.scrollToTime('08:00')
  },
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('telefono'),
        align: 'center',
        sortable: true,
        value: 'number'
      }
    ]
  },
  methods: {
    editSchedule (id) {
      console.log(id)
    },
    loadSportSchedule () {
      console.log('Fill Calendar')
      if (this.idSport === undefined) {
        this.events = []
      } else {
        this.getScheduleBySport()
      }
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        // eslint-disable-next-line no-return-assign
        requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    getEventColor (event) {
      return event.color
    },
    addDaysToToday (numDays) {
      let fecha = new Date(this.today)
      fecha.setDate(fecha.getDate() + numDays)
      console.log('Fecha')
      console.log(fecha.toISOString().slice(0, 10))
      return fecha.toISOString().slice(0, 10)
    },
    addScheduleToCalendar (items) {
      let initialTime = ''
      let finalTime = ''
      this.events = []

      for (let i = 0; i < items.length; i++) {
        initialTime = this.addDaysToToday(items[i].day) + ' ' + items[i].initialTime
        finalTime = this.addDaysToToday(items[i].day) + ' ' + items[i].finalTime
        this.events.push(
          {
            id: items[i].id,
            name: items[i].nameInstructors === null ? items[i].name : items[i].name + ' - ' + items[i].nameInstructors,
            color: items[i].color,
            start: initialTime,
            end: finalTime,
            initialTime: items[i].initialTime,
            finalTime: items[i].finalTime,
            weekday: this.convertNumberToWeekday(items[i].day),
            day: items[i].day,
            nameInstructors: items[i].nameInstructors
          }
        )
      }
    },
    convertNumberToWeekday (aNumber) {
      let weekday = ''
      switch (aNumber) {
        case 0:
          weekday = 'Lunes'
          break
        case 1:
          weekday = 'Martes'
          break
        case 2:
          weekday = 'Miércoles'
          break
        case 3:
          weekday = 'Jueves'
          break
        case 4:
          weekday = 'Viernes'
          break
        case 5:
          weekday = 'Sábado'
          break
        case 6:
          weekday = 'Domingo'
          break
      }
      return weekday
    },
    getSports () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/sport/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.directorys = response.data
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    getScheduleBySport () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/schedule_by_sport/' + this.idSport,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.schedule_by_sport = response.data
          this.addScheduleToCalendar(response.data)
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    addSportSchedule () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/schedule_sport/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idSport: this.idSport,
          day: this.weekday,
          initialTime: this.initialTime,
          finalTime: this.finalTime,
          nameInstructors: this.instructor_name
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_schedule_added'))
          this.dialog = false
          this.loadSportSchedule()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    updateSportSchedue (id) {
      this.loading = true
      this.errores = []

      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/schedule_sport/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idSport: this.idSport,
          day: this.weekday,
          initialTime: this.initialTime,
          finalTime: this.finalTime,
          nameInstructors: this.instructor_name
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.loadSportSchedule()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_schedule_updated'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteSportSchedule () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/schedule_sport/' + this.idDirectoryDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Registro con ID = ', this.idDirectoryDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_schedule_deleted'))
        this.loadSportSchedule()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    getCutingLogo () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultLogoURL)
      this.dialogImageLogo = false
      this.dialog = true
    },
    cleanFields () {
      this.initialTime = ''
      this.finalTime = ''
      this.weekday = ''
      this.instructor_name = ''
    },
    fillFields (item) {
      this.initialTime = item.initialTime
      this.finalTime = item.finalTime
      this.weekday = item.day
      this.initialTimeAux = item.initialTime
      this.finalTimeAux = item.finalTime
      this.instructor_name = item.nameInstructors
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
.edge {
    border-radius: 8px;
    border-color: #2a2738 #2a2738 #2a2738 #2a2738;
    border-width: 3px 3px 3px 3px;
    text-align: center;
    border-style: solid solid solid solid;
}
</style>
